import { createContext, useEffect, useState } from "react";
import { authenticate } from '../services/api';
import {jwtDecode} from "jwt-decode";

export const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
  
  const [currentUser, setCurrentUser] = useState(
    JSON.parse(localStorage.getItem("user")) || null
  );
  const login = async (username, password) => {
    try {
        const response = await authenticate(username, password);
        const { access, refresh } = response.data;
        localStorage.setItem("access_token", access);
        localStorage.setItem("refresh_token", refresh);
         // Decode the token to get user info
        const decoded = jwtDecode(access);
        // if username is sudoer:target, then the username becomes target
        let actual_username = username;
        if (username.includes(':')) {
          actual_username = username.split(':')[1];
        }

        setCurrentUser({
        id: decoded.user_id,
        name: actual_username,
        profilePic:
          "/images/profiles/profile1.png",
      });
      console.log("Login successful");
      return true;
    } catch (err) {
      setCurrentUser(null);
      console.log(err);
      console.log("Login failed");
      return false;
    }
    
    // Redirect to homepage after login    
  };

  const logout = ({setAuth}) => {
    setCurrentUser(null);
    setAuth(false);
  };

  useEffect(() => {
    localStorage.setItem("user", JSON.stringify(currentUser));
  }, [currentUser]);

  return (
    <AuthContext.Provider value={{ currentUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
